import type { UseMutationResult } from "@tanstack/react-query"
import { useMutation, useQueryClient } from "@tanstack/react-query"

import { queryKeys } from "~/api/cache"

import { invalidateBatteryPrice } from "./battery-price-dependents"
import type {
  BatteryProposalDto,
  UpdateBatteryProposalAddersDto,
} from "../dto/battery-proposal.dto"
import { batteryProposalService } from "../services/battery-proposal.service"

/**
 * An effective Adders save moves the pricing-input generation, so stored
 * pricing reads out of date. The save does not return pricing, so the pricing
 * read refetches along with everything derived from it.
 */
export default function useUpdateBatteryProposalAdders(): UseMutationResult<
  BatteryProposalDto,
  unknown,
  { proposalId: string; body: UpdateBatteryProposalAddersDto }
> {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ proposalId, body }) =>
      batteryProposalService.updateAdders(proposalId, body),
    onSuccess: (proposal, { proposalId }) => {
      queryClient.setQueryData(
        queryKeys.batteryProposal.byId(proposalId),
        proposal,
      )
      invalidateBatteryPrice(queryClient, proposalId)
    },
  })
}
